import { GetReviewsParamsDTO } from "@apps/reviews/services/ReviewsServiceBase";

import { GetReviewsParamsSdkDto } from "../types";

export function filterGetReviewsParams(
    params?: GetReviewsParamsSdkDto
): GetReviewsParamsDTO | undefined {
    if (!params) {
        return undefined;
    }

    return {
        productId: params.productId,
        sortingOptions: params.sortingOptions,
        onlyShopReviews: params.onlyShopReviews,
        onlyProductReviews: params.onlyProductReviews,
        onlyPinnedReviews: params.onlyPinnedReviews,
        onlyWithPhotos: params.onlyWithPhotos,
        lowestRating: params.lowestRating,
        perPage: params.perPage,
        offset: params.offset,
    };
}
